/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import React from 'react'
import Select from 'DesignSystem/Select/react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/DesignSystem/VideoCapture/Content/DeviceChooser/Content",
  value,
  options,
  disabled,
  onChange,
  style
  
}) {
  return (<React.Fragment
>
<Select
  viewPath={`${viewPath}/Select`}
 value={value}
 options={options}
 disabled={disabled}
 onChange={onChange}
 style={style}
/>
{children}
</React.Fragment>)
}